import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';

//router
import { RouterModule, Routes } from '@angular/router';

//http client
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HsbServicesAuthInterceptor } from './hsbservicesauth.interceptor';

//angular material
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {  MatButtonModule, 
          MatCheckboxModule, 
          MatToolbarModule,
          MatCardModule,
          MatProgressSpinnerModule,
          MatFormFieldModule,
          MatInputModule
      } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FlexLayoutModule } from '@angular/flex-layout';


//services
import { MediaMatcher } from '@angular/cdk/layout';
import { AuthService } from './auth.service';
import { AuthGuardService } from './auth-guard.service';
import { ErrorStackService } from './error-stack.service';
import { AutomationService } from './automation.service';
import { AutomationExporterService } from './automation-exporter.service';
import { AutomationCredentialsService } from './automation-credentials.service';
import { AutomationMapFormatTransformService } from './automation-map-format-transform.service';
import { StorageS3HttpMethodsService } from './storage-s3-http-methods.service';
import { StorageHsbshareHttpMethodsService } from './storage-hsbshare-http-methods.service';
import { PathService } from './path.service';

//components
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { MainComponent } from './main/main.component';
import { HeaderComponent } from './header/header.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ToolbarHeaderComponent } from './toolbar-header/toolbar-header.component';
import { ExporterS3Component } from './exporter-s3/exporter-s3.component';
import { MapFormatTransformS3Component } from './map-format-transform-s3/map-format-transform-s3.component';
import { CloudFolderContentComponent } from './cloud-folder-content/cloud-folder-content.component';
import { ExporterHsbshareComponent } from './exporter-hsbshare/exporter-hsbshare.component';
import { ListRootContainersComponent } from './list-root-containers/list-root-containers.component';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotFoundComponent,
    MainComponent,
    HeaderComponent,
    ToolbarComponent,
    ToolbarHeaderComponent,
    ExporterS3Component,
    MapFormatTransformS3Component,
    CloudFolderContentComponent,
    ExporterHsbshareComponent,
    ListRootContainersComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatButtonModule, 
    MatCheckboxModule,
    MatToolbarModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    MatTabsModule,
    MatRadioModule,
    MatAutocompleteModule,
    FlexLayoutModule,
    RouterModule.forRoot([
      {
          path: 'login',
          component: LoginComponent
      },
      {
          path: '',
          component: MainComponent,
          canActivate: [AuthGuardService]
      },
      {
        path: 'automation/S3/exporter',
        component: ExporterS3Component,
        canActivate: [AuthGuardService]
      },
      {
        path: 'automation/hsbShare/exporter',
        component: ExporterHsbshareComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'automation/S3/mapformattransform',
        component: MapFormatTransformS3Component,
        canActivate: [AuthGuardService]
      },
      {
        path: '**', component: NotFoundComponent
      },
  ])
  ],
  providers: [{
      provide: HTTP_INTERCEPTORS,
      useClass: HsbServicesAuthInterceptor,
      multi: true
    },
    MediaMatcher,
    AuthService,
    AuthGuardService,
    ErrorStackService,
    AutomationService,
    AutomationExporterService,
    AutomationCredentialsService,
    AutomationMapFormatTransformService,
    StorageS3HttpMethodsService,
    StorageHsbshareHttpMethodsService,
    PathService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts